import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";

export const rowData = [
    { idPaymentReceive: "PM001", srNo: 1, receiptNo: "RCP1001", date: "2024-02-06", refNo: "REF12345", bankName: "ABC Bank", chequeNo: "CHQ789456", chequeDate: "2024-02-05", account: "Savings", paymentMode: "Cheque", amountRec: 5000, remarks: "Payment received", approvalStatus: "Approved" },
    { idPaymentReceive: "PM002", srNo: 2, receiptNo: "RCP1002", date: "2024-02-05", refNo: "REF67890", bankName: "XYZ Bank", chequeNo: "CHQ123789", chequeDate: "2024-02-04", account: "Current", paymentMode: "Cheque", amountRec: 10000, remarks: "Partial payment", approvalStatus: "Pending" },
    { idPaymentReceive: "PM003", srNo: 3, receiptNo: "RCP1003", date: "2024-02-04", refNo: "REF54321", bankName: "PQR Bank", chequeNo: "CHQ987654", chequeDate: "2024-02-03", account: "Business", paymentMode: "Online Transfer", amountRec: 7500, remarks: "Advance payment", approvalStatus: "Approved" },
    { idPaymentReceive: "PM004", srNo: 4, receiptNo: "RCP1004", date: "2024-02-03", refNo: "REF24680", bankName: "LMN Bank", chequeNo: "CHQ654321", chequeDate: "2024-02-02", account: "Joint", paymentMode: "UPI", amountRec: 2000, remarks: "Final settlement", approvalStatus: "Rejected" },
    { idPaymentReceive: "PM005", srNo: 5, receiptNo: "RCP1005", date: "2024-02-02", refNo: "REF13579", bankName: "DEF Bank", chequeNo: "CHQ369258", chequeDate: "2024-02-01", account: "Savings", paymentMode: "Cash", amountRec: 4500, remarks: "Cash deposit", approvalStatus: "Approved" },
    { idPaymentReceive: "PM001", srNo: 1, receiptNo: "RCP1001", date: "2024-02-06", refNo: "REF12345", bankName: "ABC Bank", chequeNo: "CHQ789456", chequeDate: "2024-02-05", account: "Savings", paymentMode: "Cheque", amountRec: 5000, remarks: "Payment received", approvalStatus: "Approved" },
    { idPaymentReceive: "PM002", srNo: 2, receiptNo: "RCP1002", date: "2024-02-05", refNo: "REF67890", bankName: "XYZ Bank", chequeNo: "CHQ123789", chequeDate: "2024-02-04", account: "Current", paymentMode: "Cheque", amountRec: 10000, remarks: "Partial payment", approvalStatus: "Pending" },
    { idPaymentReceive: "PM003", srNo: 3, receiptNo: "RCP1003", date: "2024-02-04", refNo: "REF54321", bankName: "PQR Bank", chequeNo: "CHQ987654", chequeDate: "2024-02-03", account: "Business", paymentMode: "Online Transfer", amountRec: 7500, remarks: "Advance payment", approvalStatus: "Approved" },
    { idPaymentReceive: "PM004", srNo: 4, receiptNo: "RCP1004", date: "2024-02-03", refNo: "REF24680", bankName: "LMN Bank", chequeNo: "CHQ654321", chequeDate: "2024-02-02", account: "Joint", paymentMode: "UPI", amountRec: 2000, remarks: "Final settlement", approvalStatus: "Rejected" },
    { idPaymentReceive: "PM005", srNo: 5, receiptNo: "RCP1005", date: "2024-02-02", refNo: "REF13579", bankName: "DEF Bank", chequeNo: "CHQ369258", chequeDate: "2024-02-01", account: "Savings", paymentMode: "Cash", amountRec: 4500, remarks: "Cash deposit", approvalStatus: "Approved" },
    { idPaymentReceive: "PM001", srNo: 1, receiptNo: "RCP1001", date: "2024-02-06", refNo: "REF12345", bankName: "ABC Bank", chequeNo: "CHQ789456", chequeDate: "2024-02-05", account: "Savings", paymentMode: "Cheque", amountRec: 5000, remarks: "Payment received", approvalStatus: "Approved" },
    { idPaymentReceive: "PM002", srNo: 2, receiptNo: "RCP1002", date: "2024-02-05", refNo: "REF67890", bankName: "XYZ Bank", chequeNo: "CHQ123789", chequeDate: "2024-02-04", account: "Current", paymentMode: "Cheque", amountRec: 10000, remarks: "Partial payment", approvalStatus: "Pending" },
    { idPaymentReceive: "PM003", srNo: 3, receiptNo: "RCP1003", date: "2024-02-04", refNo: "REF54321", bankName: "PQR Bank", chequeNo: "CHQ987654", chequeDate: "2024-02-03", account: "Business", paymentMode: "Online Transfer", amountRec: 7500, remarks: "Advance payment", approvalStatus: "Approved" },
    { idPaymentReceive: "PM004", srNo: 4, receiptNo: "RCP1004", date: "2024-02-03", refNo: "REF24680", bankName: "LMN Bank", chequeNo: "CHQ654321", chequeDate: "2024-02-02", account: "Joint", paymentMode: "UPI", amountRec: 2000, remarks: "Final settlement", approvalStatus: "Rejected" },
    { idPaymentReceive: "PM005", srNo: 5, receiptNo: "RCP1005", date: "2024-02-02", refNo: "REF13579", bankName: "DEF Bank", chequeNo: "CHQ369258", chequeDate: "2024-02-01", account: "Savings", paymentMode: "Cash", amountRec: 4500, remarks: "Cash deposit", approvalStatus: "Approved" },
    { idPaymentReceive: "PM001", srNo: 1, receiptNo: "RCP1001", date: "2024-02-06", refNo: "REF12345", bankName: "ABC Bank", chequeNo: "CHQ789456", chequeDate: "2024-02-05", account: "Savings", paymentMode: "Cheque", amountRec: 5000, remarks: "Payment received", approvalStatus: "Approved" },
    { idPaymentReceive: "PM002", srNo: 2, receiptNo: "RCP1002", date: "2024-02-05", refNo: "REF67890", bankName: "XYZ Bank", chequeNo: "CHQ123789", chequeDate: "2024-02-04", account: "Current", paymentMode: "Cheque", amountRec: 10000, remarks: "Partial payment", approvalStatus: "Pending" },
    { idPaymentReceive: "PM003", srNo: 3, receiptNo: "RCP1003", date: "2024-02-04", refNo: "REF54321", bankName: "PQR Bank", chequeNo: "CHQ987654", chequeDate: "2024-02-03", account: "Business", paymentMode: "Online Transfer", amountRec: 7500, remarks: "Advance payment", approvalStatus: "Approved" },
    { idPaymentReceive: "PM004", srNo: 4, receiptNo: "RCP1004", date: "2024-02-03", refNo: "REF24680", bankName: "LMN Bank", chequeNo: "CHQ654321", chequeDate: "2024-02-02", account: "Joint", paymentMode: "UPI", amountRec: 2000, remarks: "Final settlement", approvalStatus: "Rejected" },
    { idPaymentReceive: "PM005", srNo: 5, receiptNo: "RCP1005", date: "2024-02-02", refNo: "REF13579", bankName: "DEF Bank", chequeNo: "CHQ369258", chequeDate: "2024-02-01", account: "Savings", paymentMode: "Cash", amountRec: 4500, remarks: "Cash deposit", approvalStatus: "Approved" },
];

// export const colDefs = [
//     {
//         field: "idPaymentReceive",
//         headerName: "ID Payment Receive",
//         minWidth: window.innerWidth * 0.11,
//         flex: 1,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "srNo",
//         headerName: "Sr No",
//         minWidth: window.innerWidth * 0.05,
//         flex: 0.5,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "receiptNo",
//         headerName: "Receipt No",
//         minWidth: window.innerWidth * 0.07,
//         flex: 1,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "date",
//         headerName: "Date",
//         minWidth: window.innerWidth * 0.08,
//         flex: 0.9,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "refNo",
//         headerName: "Ref No",
//         minWidth: window.innerWidth * 0.08,
//         flex: 0.9,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "bankName",
//         headerName: "Bank Name",
//         minWidth: window.innerWidth * 0.17,
//         flex: 1.5,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "chequeNo",
//         headerName: "Cheque No",
//         minWidth: window.innerWidth * 0.08,
//         flex: 1,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "chequeDate",
//         headerName: "Cheque Date",
//         minWidth: window.innerWidth * 0.08,
//         flex: 1,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "account",
//         headerName: "Account",
//         minWidth: window.innerWidth * 0.08,
//         flex: 1,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "paymentMode",
//         headerName: "Payment Mode",
//         minWidth: window.innerWidth * 0.1,
//         flex: 1,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "amountRec",
//         headerName: "Amount Rec",
//         minWidth: window.innerWidth * 0.08,
//         flex: 1,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "remarks",
//         headerName: "Remarks",
//         minWidth: window.innerWidth * 0.1,
//         flex: 1,
//         filter: true,
//         floatingFilter: true,
//     },
//     {
//         field: "approvalStatus",
//         headerName: "Approval Status",
//         minWidth: window.innerWidth * 0.1,
//         flex: 1,
//         filter: true,
//         floatingFilter: true,
//     },
// ];

// export const table2Data = [];

// export const table2ColDefs = [];

export const PaymentVoucherPopUp = (props) => {

    return (
        <ModalBasic
            id="voucher-receipt-details"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className="input-fields bg-white p-[30px] shadow-normalShadow rounded-[10px]">
                <div className="item-grp">
                    <span className="text-blue text-[16px] font-semibold">Receipt details</span>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mt-[12px] pb-[10px] border-b border-slate-200">
                        <div className="input-outer-grp col-span-2 flex gap-2.5">
                            <div className="input-grp w-[25%]">
                                <label>Receipt no</label>
                                <TextInput
                                    id="receiptNo"
                                    name="receiptNo"
                                    disabled
                                    value={props.receiptDetails.receiptNo}
                                    handleChange={(event) => props.handleChange(event, "receiptNo")}
                                />
                            </div>
                            <div className="input-grp w-[75%]">
                                <label>Select vendor</label>
                                <TextInput
                                    id="selectVendor"
                                    name="selectVendor"
                                    value={props.receiptDetails.selectedVendorName}
                                    //handleChange={(event) => props.handleChange(event, "selectVendor")}
                                    handleOnClick={(event) => props.handleOnClick(event, "selectVendor")}
                                    className={props.validState?.error?.selectedVendorName !== undefined ? "error" : ""}
                                />
                                {/* <TextInput id="selectVendor" name="selectVendor" value={props.receiptDetails.selectVendor} handleChange={(event) => props.handleChange(event, "selectVendor")} /> */}
                            </div>
                        </div>
                        <div className="input-grp">
                            <label>Payment date</label>
                            <TextInput type="date" id="paymentDate" name="paymentDate" value={props.receiptDetails.paymentDate} handleChange={(event) => props.handleChange(event, "paymentDate")} className={props.validState?.error?.paymentDate !== undefined ? "error" : ""} />
                        </div>
                        <div className="input-grp">
                            <label>Ref. no</label>
                            <TextInput type="text" id="refNo" name="refNo" value={props.receiptDetails.refNo} handleChange={(event) => props.handleChange(event, "refNo")} />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-[0.5fr_1.5fr_1fr_1fr] gap-2.5 mt-2.5 mb-3">
                        <div className="input-grp">
                            <label>Payment mode</label>
                            {/* <SingleSelectWithSearch
                                id="paymentMode"
                                name="paymentMode"
                                optionArray={props.paymentModeList}
                                value={props.receiptDetails.paymentMode}
                                setFilterParameters={(event) => props.handleSelectChange(event, "paymentMode")}
                            /> */}
                            <SingleSelectWithSearch
                                drpIdentity={"paymentMode"}
                                optionArray={props.paymentModeList}
                                value={props.receiptDetails.paymentModeName}
                                //setFilterParameters={(id, name, drpIdentity) => props.setFilterParametersForSelector(id, name, drpIdentity)}
                                handleChangeTest={props.handleSelectChange}
                                searchText={props.receiptDetails.paymentModeName}
                                classParams={props.validState?.error?.paymentModeName !== undefined ? "error" : ""}
                                setFilterParameters={props.setFilterParametersTest}
                            //value={this.state.idBank}
                            //handleChangeTest={this.handleChangeTest.bind(this)}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Select bank</label>
                            {/* <SingleSelectWithSearch
                                id="selectBank"
                                name="selectBank"
                                optionArray={props.bankList}
                                value={props.receiptDetails.selectBank}
                                setFilterParameters={(event) => props.handleSelectChange(event, "selectBank")}
                            /> */}
                            <SingleSelectWithSearch
                                drpIdentity={"selectBank"}
                                optionArray={props.bankList}
                                value={props.receiptDetails.idBank}
                                //setFilterParameters={(id, name, drpIdentity) => props.setFilterParametersForSelector(id, name, drpIdentity)}
                                handleChangeTest={props.handleSelectChange}
                                searchText={props.receiptDetails.bankName}
                                classParams={props.validState?.error?.idBank !== undefined ? "error" : ""}
                                setFilterParameters={props.setFilterParametersTest}
                            //value={this.state.idBank}
                            //handleChangeTest={this.handleChangeTest.bind(this)}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Select series</label>
                            {/* <SingleSelectWithSearch
                                id="selectSeries"
                                name="selectSeries"
                                value={props.receiptDetails.selectSeries}
                                handleChangeTest={(event) => props.handleSelectChange(event, "selectSeries")}
                            /> */}
                            <TextInput
                                id="selectSeries"
                                name="selectSeries"
                                value={props.receiptDetails.chequeBookSeries}
                                handleOnClick={(event) => props.handleOnClick(event, "selectSeries")}
                                // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Cheque no</label>
                            <SingleSelectWithSearch
                                id="chequeNo"
                                name="chequeNo"
                                drpIdentity={"chequeNo"}
                                optionArray={props.chequeNoList}
                                value={props.receiptDetails.idChequeBookMaster}
                                handleChangeTest={(event) => props.handleSelectChange(event, "chequeNo")}
                                setFilterParameters={props.setFilterParametersTest}
                                searchText={props.receiptDetails.chequeNo}
                                
                            />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Cheque date</label>
                            <TextInput type="date" id="chequeDate" 
                            name="chequeDate"
                            value={props.receiptDetails.chequeDate} 
                            handleChange={(event) => props.handleChange(event, "chequeDate")} 
                            // className={props.validState?.error?.chequeDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Outstanding balance</label>
                            <TextInput
                                type="number"
                                id="outStandingBalance"
                                name="outStandingBalance"
                                value={props.receiptDetails.outStandingBalance}
                                handleChange={(event) => props.handleChange(event, "outStandingBalance")}
                                disabled={true} 
                                // className={props.validState?.error?.outStandingBalance !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Pending balance</label>
                            <TextInput disabled={true} type="number" id="pendingBalance" name="pendingBalance" value={props.receiptDetails.pendingBalance} handleChange={(event) => props.handleChange(event, "pendingBalance")}/>
                        </div>
                        <div className="input-grp">
                            <label>Paid amount</label>
                            <TextInput type="number" id="paidAmount" name="paidAmount" value={props.receiptDetails.paidAmount} handleChange={(event) => props.handleChange(event, "paidAmount")} className={props.validState?.error?.paidAmount !== undefined ? "error" : ""}/>
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3.5">
                        <div className="input-grp">
                            <label>Remarks</label>
                            <TextInput type="text" id="remarks" name="remarks" value={props.receiptDetails.remarks} handleChange={(event) => props.handleChange(event, "remarks")} />
                        </div>
                    </div>
                    <div className="btn-grp inline-flex gap-2.5">
                        <button className="update-btn btns"
                            onClick={() => props.submit()}
                            disabled={props.isSaving}
                        >
                           {props.receiptDetails.updateStatus > 0 ?  "Update" : "Save"} 
                        </button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    );
}